<template>
  <section :class="$style.container">
    <slot name="item" />
  </section>
</template>

<style lang="scss" module>
.container {
  padding: 8px;
  background-color: $color-surface-accent-primary-light;
  border-radius: $border-radius-v2-base;
}
</style>
